import { render, staticRenderFns } from "./report2.vue?vue&type=template&id=7635cb02&scoped=true&"
import script from "./report2.vue?vue&type=script&lang=js&"
export * from "./report2.vue?vue&type=script&lang=js&"
import style0 from "./report2.vue?vue&type=style&index=0&id=7635cb02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7635cb02",
  null
  
)

export default component.exports